export default "__VITE_ASSET__C0X8XFQl__"